import React, {useMemo} from 'react';
import {Text} from 'components-lib';
import {SelectionEnum, SelectionListItems} from 'filters-selections';

export function RolloverProgramFormFields() {
  const selectionListItems = useMemo(() => {
    const fieldsListDefault = [SelectionEnum.ProgramMultiSelection];
    const list = fieldsListDefault;
    return <SelectionListItems list={list} />;
  }, []);

  return (
    <>
      <Text.Paragraph>Select the destination programs to roll-over to</Text.Paragraph>
      {selectionListItems}
      {/* TODO: what if program name doesn't include year? How to filter programs by year? */}
      {/* <ProgramYearMultiFilter /> */}
    </>
  );
}
